
import { Vue, Component, Ref } from 'vue-property-decorator';
import HeadlineImageField from '@/components/spu/fields/HeadlineImageField.vue';
import lazyInject from '@/di';
import ShopService from '@/services/shop.service';
import { FormModel } from 'ant-design-vue';

@Component({
  components: {
    HeadlineImageField,
  },
  name: 'VirtualPOIDrawer',
})
export default class extends Vue {
  visible = false;

  @lazyInject(ShopService)
  shopService!: ShopService;

  @Ref()
  formRef!: FormModel;

  modalVisible = false;

  labelCol = { span: 4 };
  wrapperCol = { span: 14 };

  selectedRecord: any = null;

  virtualPoi = '';
  formData: any = {
    shop_license: '', // 营业执照图片
    adcode: '',
    address: '',
    companyName: '', //  营业执照名称
    creditCode: '', // 营业执照编号
    name: '',
    location: '', // 营业执照地址坐标
  };

  columns = [
    {
      title: '省',
      dataIndex: 'province',
      key: 'province',
      align: 'center',
    },
    {
      title: '市',
      dataIndex: 'city',
      key: 'city',
      align: 'center',
    },
    {
      title: '区',
      dataIndex: 'district',
      key: 'district',
      align: 'center',
    },
    {
      title: '详细地址',
      dataIndex: 'formatted_address',
      key: 'formatted_address',
      align: 'center',
    },
  ];

  rules = {
    name: [
      { required: true, message: '店铺名称不能为空', trigger: 'blur' },
    ],
  };

  data = [];

  rowSelection = {
    type: 'radio', // 关键：设置为 'radio' 实现单选
    selectedRowKeys: [], // 存储当前选中行的 key
    selectedRecords: [], // 存储当前选中行的数据
    onChange: (selectedRowKeys: any, selectedRows: any) => {
      // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
      // 更新选中状态
      this.selectedRecord = selectedRows[0];
      this.rowSelection.selectedRecords = selectedRows;
      this.rowSelection.selectedRowKeys = selectedRowKeys;
      // 可以在这里处理选中行的数据，例如：
    },
  };

  ModalText = 'Content of the modal';

  showModal() {
    this.modalVisible = true;
  }

  async getlnglat() {
    const data = {
      address: this.formData.address,
    };
    const geo = await this.shopService.postGeoAddress(data);
    if (geo) {
      if (geo.length === 1) {
        const selectedRecords: any = geo[0];
        this.formData.location = selectedRecords.location;
        this.formData.adcode = selectedRecords.adcode;
      } else {
        this.data = geo;
      }
    }
  }

  async getLicense(val: any) {
    // console.log(val);
    const params = {
      imgUrlId: val.id,
    };
    this.formData.shop_license = val.id;
    const res = await this.shopService.postShopLicense(params);
    if (res) {
      this.formData.creditCode = res.creditCode;
      this.formData.companyName = res.companyName;
      this.formData.address = res.businessAddress;
      const data = {
        address: res.businessAddress,
      };
      const geo = await this.shopService.postGeoAddress(data);
      if (geo) {
        if (geo.length === 1) {
          const selectedRecords: any = geo[0];
          this.formData.location = selectedRecords.location;
          this.formData.adcode = selectedRecords.adcode;
        } else {
          this.data = geo;
        }
      }
    }
  }

  handleOk() {
    this.modalVisible = false;
    const selectedRecords: any = this.rowSelection.selectedRecords[0];
    this.formData.location = selectedRecords.location;
    this.formData.adcode = selectedRecords.adcode;
  }

  handleCancel() {
    this.modalVisible = false;
  }

  showDrawer() {
    this.visible = true;
  }

  onChange(value: any) {
    console.log(value);
  }

  async createVirtualPoi() {
    const params = {
      poi: this.virtualPoi,
    };
    const res = await this.shopService.postPoiUrl(params);
    this.$copyText(String(res)).then(() => {
      this.$message.success('复制成功');
    }, (err) => {
      this.$message.error(`复制失败:${err}`);
    });
  }

  async onClose() {
    this.visible = false;
    this.formData = {
      shop_license: '', // 营业执照图片
      adcode: '',
      address: '',
      companyName: '', //  营业执照名称
      creditCode: '', // 营业执照编号
      name: '',
      location: '', // 营业执照地址坐标
    };
    this.selectedRecord = null;
    this.data = [];
    this.rowSelection.selectedRowKeys = [];
    this.rowSelection.selectedRecords = [];
    this.virtualPoi = '';
    this.$emit('search');
  }
  async submit() {
    this.formRef.validate(async (valid) => {
      if (valid) {
        const res = await this.shopService.shopEcAddOnlineShop(this.formData);
        if (res) {
          this.$message.success('创建成功');
          this.virtualPoi = res.poi;
          this.onClose();
        }
      }
    });
  }
}
